/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Top_CenterInputs */



/**
* | output |
* | --- |
* | "Top Center" |
*
* @param {Input_Position_Top_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_top_center = /** @type {((inputs?: Input_Position_Top_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Top_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Haut Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro superiore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верхний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("顶部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro superior")
	return /** @type {LocalizedString} */ ("Top Center")
});